export const MAX_INTERESTS = 8;
export const MAX_INTEREST_LENGTH = 30;

export function cleanInterest(value) {
  return String(value ?? '')
    .replace(/[\u0000-\u001f\u007f]/g, ' ')
    .replace(/\s+/g, ' ')
    // Trim before stripping the hash, or a leading space defeats the anchor
    // and " #cycling" survives as a tag that matches nothing.
    .trim()
    .replace(/^#+/, '')
    .trim()
    .slice(0, MAX_INTEREST_LENGTH)
    .toLocaleLowerCase();
}

export function normalizeInterests(values) {
  const unique = [];
  const seen = new Set();

  for (const raw of Array.isArray(values) ? values : []) {
    const interest = cleanInterest(raw);
    if (!interest || seen.has(interest)) continue;
    seen.add(interest);
    unique.push(interest);
    if (unique.length === MAX_INTERESTS) break;
  }

  return unique;
}

export function sharedInterests(left, right) {
  const theirs = new Set(normalizeInterests(right));
  return normalizeInterests(left).filter((interest) => theirs.has(interest));
}
